class Banner extends HTMLElement {
  constructor() {
    super();
    this.storageKey = '';
  }

  get closeButton() {
    return this.querySelector('[data-trigger=close]');
  }

  handleDefaultVisibility() {
    const currentPath = window.location.pathname;
    const closedData = this.getClosedData();

    const isPathValid = this.shouldShowBasedOnPath(currentPath);

    if (!isPathValid) {
      this.hideBanner();
      return;
    }

    if (!closedData) {
      this.showBanner();
      return;
    }

    const closedTime = new Date(closedData.timestamp);
    const currentTime = new Date();
    const diffTime = currentTime - closedTime;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    if (diffDays < closedData.expirationDays) {
      this.hideBanner();
    } else {
      this.showBanner();
      this.removeClosedData();
    }
  }


  shouldShowBasedOnPath(path) {
    const pathsToTrigger = ['/logistica', '/logistics'];
  
    const excludedLocales = ['/es', '/uy', '/cl'];
  
    if (excludedLocales.some(locale => path.startsWith(locale))) {
      return;
    }
  
    return pathsToTrigger.some(triggerPath => path.includes(triggerPath));
  }


  saveClosedData() {
    const data = {
      timestamp: new Date().toISOString(),
      expirationDays: this.expirationDays || 0, 
    };
    localStorage.setItem(this.storageKey, JSON.stringify(data));
  }

  getClosedData() {
    const data = localStorage.getItem(this.storageKey);
    return data ? JSON.parse(data) : null;
  }


  removeClosedData() {
    localStorage.removeItem(this.storageKey);
  }

  hideBanner() {
    this.classList.add('hidden');
  }

  showBanner() {
    this.classList.remove('hidden');
  }

  handleCloseButton(e) {
    this.hideBanner();
    this.saveClosedData();
  }

  connectedCallback() {
    if (this.id) {
      this.storageKey = `banner-${this.id}-closed`;
    }

    this.expirationDays = 0; 
    if (this.hasAttribute('expiration-days')) {
      this.expirationDays = parseInt(this.getAttribute('expiration-days'), 10) || 0;
    }

    this.bind();
    this.handleDefaultVisibility();
  }

  bind() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', e => this.handleCloseButton(e));
    }
  }
}

customElements.define('c-banner', Banner);